import { Box, type BoxProps, Text } from 'ink';
import type { KeyDetails } from './tableTypes';

/*
  See Table component
*/
export default function TableEnd({
  keyDetails,
  ...props
}: BoxProps & {
  keyDetails: KeyDetails;
}) {
  let content = '└';
  content += Object.values(keyDetails)
    .map(({ width }) => '─'.repeat(width + 2))
    .join('┴');
  content += '┘';

  return (
    <Box {...props}>
      <Text>{content}</Text>
    </Box>
  );
}
